module.exports = __webpack_public_path__ + "img/ADA.a429378d.svg";